import axios from 'axios'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

http.interceptors.request.use(config => {
  config.diagnosticStartedAt = Date.now()
  const token = window.localStorage.getItem('sandbox.token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

http.interceptors.response.use(response => response, error => {
  // Axios 的原始异常含有 Authorization 和请求正文，诊断时只输出固定元数据。
  const config = error.config || {}
  const requestId = (error.response && error.response.headers && error.response.headers['x-request-id']) || ''
  console.warn('[sandbox.http] request_failed', {
    requestId: /^[a-f0-9-]{36}$/.test(requestId) ? requestId : '',
    method: String(config.method || '').toUpperCase(),
    status: (error.response && error.response.status) || 0,
    code: ['ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK', 'ERR_BAD_RESPONSE', 'ERR_BAD_REQUEST', 'ERR_CANCELED'].includes(error.code) ? error.code : 'REQUEST_FAILED',
    durationMs: config.diagnosticStartedAt ? Date.now() - config.diagnosticStartedAt : null
  })
  if (error.response && error.response.status === 401) {
    window.localStorage.removeItem('sandbox.token')
    window.localStorage.removeItem('sandbox.user')
    if (window.location.hash !== '#/login') {
      window.location.hash = '#/login'
    }
  }
  return Promise.reject(error)
})

export default http
